// import React, { useState } from 'react';
// import {
//   clearUser,
//   setCurrentLang,
//   setDarkMode,
// } from '../services/store/slices/user';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   Badge,
//   Button,
//   Divider,
//   Dropdown,
//   Flex,
//   Input,
//   Avatar,
//   Tag,
//   Tabs,
//   Checkbox,
//   Spin,
// } from 'antd';
// import { IoCheckmarkDoneCircleOutline, IoSearchOutline } from 'react-icons/io5';
// import { RiFullscreenLine } from 'react-icons/ri';
// import { CgMenuLeft, CgMenuRight } from 'react-icons/cg';
// import { LiaLongArrowAltRightSolid } from 'react-icons/lia';
// import { MdClose, MdOutlineDarkMode } from 'react-icons/md';
// import { IoNotificationsOutline } from 'react-icons/io5';
// import {
//   MdDarkMode,
//   MdLanguage,
//   MdLightMode,
//   MdOutlineSearch,
// } from 'react-icons/md';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
//   LogoutOutlined,
//   UserOutlined,
//   DownOutlined,
//   SettingOutlined,
// } from '@ant-design/icons';
// import SearchComponent from './InputSearchHeader';
// import imgen from '../assets/us.svg';
// import imgar from '../assets/ae.svg';
// import imgavater from '../assets/avatar-1.jpg';
// import { FaLongArrowAltRight } from 'react-icons/fa';
// import { CiClock2 } from 'react-icons/ci';
// import { queryKeys } from '../services/react-query/queryKeys';
// import { useQuery } from '@tanstack/react-query';
// import { getNotifications } from '../network/notifications';
// import dayjs from 'dayjs';
// import { LuListTodo } from 'react-icons/lu';
// import MobileMenu from './MobileMenu';
// const Header = ({ collapsed, setCollapsed }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [openMenu, setOpenMenu] = useState(false);
//   const { currentLang, darkMode, userName, companyName } = useSelector(
//     (state) => state.user
//   );
//   const handleDarkMode = (dark) => {
//     dispatch(setDarkMode(dark));
//   };
//   const { data: notifications, isLoading } = useQuery({
//     queryKey: [queryKeys.getNotifications],
//     queryFn: () => getNotifications(currentLang),
//   });
//   const items = [
//     {
//       key: 'en',
//       label: (
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <img
//             src={imgen}
//             alt="en"
//             style={{ width: '15px', height: '15px', cursor: 'pointer' }}
//           />
//           <span
//             style={{ marginLeft: '10px' }}
//             className="text-[#272a3a] font-[400] text-[14px]"
//           >
//             English
//           </span>
//         </div>
//       ),
//     },
//     {
//       key: 'ar',
//       label: (
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <img src={imgar} alt="ar" style={{ width: '15px', height: '15px' }} />
//           <span
//             style={{ marginLeft: '10px' }}
//             className="text-[#272a3a] font-[400] text-[14px]"
//           >
//             العربية
//           </span>
//         </div>
//       ),
//     },
//   ];
//   const handleSignOut = () => {
//     dispatch(clearUser());
//     localStorage.clear();
//     navigate('/login');
//   };
//   const itemsTabs = [
//     {
//       key: '1',
//       label: `All (${notifications?.message?.notification_logs?.length || 0})`,
//       children: (
//         <>
//           {isLoading ? (
//             <div className="flex items-center justify-center h-[200px]">
//               <Spin />
//             </div>
//           ) : (
//             <div className="">
//               {notifications?.message?.notification_logs?.map((item, id) => (
//                 <div
//                   key={id}
//                   // className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#DAF7FE] cursor-pointer"
//                   className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#dafee3] cursor-pointer"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const name = item?.document_type
//                       .replace(/ /g, '-')
//                       .toLowerCase();
//                     navigate(`/${name}/edit/${item?.document_name}`);
//                   }}
//                 >
//                   <div className=" w-[30px] h-[20px] bg-[#DAF7FE] rounded-[50%] flex items-center justify-center">
//                     <IoCheckmarkDoneCircleOutline
//                       className="text-[#0b9640]"
//                       size={15}
//                     />
//                   </div>
//                   <div className="flex flex-col items-start gap-2">
//                     <h3 className="text-[#495057] text-[.875rem] font-[600] flex items-center flex-wrap gap-1">
//                       Your <b>{item?.from_user}</b>
//                       {/* {item?.description} */}
//                       <div
//                         className=""
//                         dangerouslySetInnerHTML={{ __html: item?.subject }}
//                       />
//                     </h3>
//                     <p className="text-[#878a99]  font-[500] text-[12px] flex items-center gap-1">
//                       {' '}
//                       <CiClock2 />{' '}
//                       {dayjs(item?.creation).format('YYYY-MM-DD h:m')}
//                     </p>
//                   </div>
//                   <Checkbox />
//                 </div>
//               ))}
//             </div>
//           )}
//         </>
//       ),
//     },
//     // {
//     //   key: '2',
//     //   label: 'Message',
//     //   children: (
//     //     <>
//     //       <div className="">
//     //         {[1, 2, 3, 4]?.map((item) => (
//     //           <div
//     //             key={item}
//     //             className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#DAF7FE] cursor-pointer"
//     //             onClick={(e) => e.stopPropagation()}
//     //           >
//     //             <div className=" w-[30px] h-[20px] bg-[#DAF7FE] rounded-[50%] flex items-center justify-center">
//     //               <IoCheckmarkDoneCircleOutline
//     //                 className="text-[#687cfe]"
//     //                 size={15}
//     //               />
//     //             </div>
//     //             <div className="flex flex-col items-start gap-2">
//     //               <h3 className="text-[#495057] text-[.875rem] font-[600] flex items-center flex-wrap gap-1">
//     //                 Your <b>Elite</b>
//     //                 author Graphic Optimization
//     //                 <p className="text-[#ff7f5d]">reward</p>
//     //                 is ready!
//     //               </h3>
//     //               <p className="text-[#878a99]  font-[500] text-[12px] flex items-center gap-1">
//     //                 {' '}
//     //                 <CiClock2 /> Just 30 sec ago
//     //               </p>
//     //             </div>
//     //             <Checkbox />
//     //           </div>
//     //         ))}
//     //       </div>
//     //     </>
//     //   ),
//     // },
//     // {
//     //   key: '3',
//     //   label: 'Alerts',
//     //   children: (
//     //     <>
//     //       <div className="">
//     //         {[1, 2, 3, 4]?.map((item) => (
//     //           <div
//     //             key={item}
//     //             className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#DAF7FE] cursor-pointer"
//     //             onClick={(e) => e.stopPropagation()}
//     //           >
//     //             <div className=" w-[30px] h-[20px] bg-[#DAF7FE] rounded-[50%] flex items-center justify-center">
//     //               <IoCheckmarkDoneCircleOutline
//     //                 className="text-[#687cfe]"
//     //                 size={15}
//     //               />
//     //             </div>
//     //             <div className="flex flex-col items-start gap-2">
//     //               <h3 className="text-[#495057] text-[.875rem] font-[600] flex items-center flex-wrap gap-1">
//     //                 Your <b>Elite</b>
//     //                 author Graphic Optimization
//     //                 <p className="text-[#ff7f5d]">reward</p>
//     //                 is ready!
//     //               </h3>
//     //               <p className="text-[#878a99]  font-[500] text-[12px] flex items-center gap-1">
//     //                 {' '}
//     //                 <CiClock2 /> Just 30 sec ago
//     //               </p>
//     //             </div>
//     //             <Checkbox />
//     //           </div>
//     //         ))}
//     //       </div>
//     //     </>
//     //   ),
//     // },
//   ];
//   const itemsNotification = [
//     {
//       type: 'group',
//       label: (
//         <>
//           <div
//             className="bg-[#0b9640] p-3 flex items-center justify-between"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <h6 className="text-[#fff]">Notifications</h6>
//             <Tag
//               color="#f9fbfc"
//               style={{
//                 color: '#272a3a',
//               }}
//             >
//               {notifications?.message?.notification_logs?.length} New
//             </Tag>
//           </div>
//         </>
//       ),
//       children: [1]?.map((item) => ({
//         key: item?.key,
//         label: (
//           <>
//             <div
//               className="notification-card"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <Tabs defaultActiveKey="1" items={itemsTabs} type="card" />
//             </div>
//           </>
//         ),
//       })),
//     },
//     // {
//     //   label: "مشاهدة الكل",
//     //   key: "30",
//     //   className: "view-all",
//     //   onClick: () => {
//     //     console.log("click");
//     //   }
//     // },
//   ];
//   const chanageLang = ({ key }) => {
//     console.log(key);
//     dispatch(setCurrentLang(key));
//     document.getElementsByTagName('html')[0].setAttribute('lang', key);
//   };
//   const handleFullScreen = () => {
//     if (document.fullscreenElement) {
//       document.exitFullscreen();
//     } else {
//       document.documentElement.requestFullscreen();
//     }
//   };
//   return (
//     <div
//       className="header"
//       style={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         width: '100%',
//         height: '100%',
//       }}
//     >
//       <Flex
//         align="center"
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           gap: '10px',
//         }}
//       >
//         <Button
//           type="text"
//           icon={
//             collapsed ? (
//               <LiaLongArrowAltRightSolid size={25} />
//             ) : (
//               <CgMenuLeft size={25} />
//             )
//           }
//           onClick={() => setCollapsed(!collapsed)}
//           className="lg:flex hidden"
//           style={{
//             fontSize: '16px',
//           }}
//         />
//         <Button
//           type="text"
//           danger={openMenu ? true : false}
//           icon={openMenu ? <MdClose size={25} /> : <CgMenuLeft size={25} />}
//           onClick={() => setOpenMenu(!openMenu)}
//           className="flex lg:hidden"
//           style={{
//             fontSize: '16px',
//           }}
//         />
//         <Input.Search
//           className={`search-input ${
//             darkMode ? 'dark-search' : 'light-search'
//           }`}
//           placeholder="search..."
//           allowClear
//           onSearch={(value) => console.log(value)}
//           enterButton={false}
//           width={200}
//           prefix={<MdOutlineSearch style={{ color: '#495057' }} size={18} />}
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         />
//         {/* <SearchComponent /> */}
//       </Flex>
//       <Flex align="center" className="own-header-space">
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           <div onClick={handleFullScreen} className="fullscreen">
//             <RiFullscreenLine size={25} color={darkMode ? '#fff' : '#505d69'} />
//           </div>
//         </div>
//         {/* <div className="language">
//           <Dropdown
//             placement="bottom"
//             arrow={{ pointAtCenter: true }}

//             trigger={['hover']}
//             menu={{ items: items, onClick: chanageLang }}
//             style={{
//               height: '20px',
//             }}
//           >
//             <Space
//               align="center"
//               style={{
//                 fontSize: '16px',
//                 fontWeight: '600',
//                 cursor: 'pointer',
//                 height: '20px',
//               }}
//               className="lang-dropdown"
//             >
//               <span className="lang-text">
//                 {currentLang === 'en' ? 'Language' : 'اللغة'}

//               </span>
//               <MdLanguage />
//             </Space>
//           </Dropdown>
//         </div> */}
//         <div
//           className=""
//           style={{
//             height: '20px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           <Dropdown
//             placement="bottom"
//             arrow={{ pointAtCenter: true }}
//             trigger={['hover']}
//             menu={{ items: items, onClick: chanageLang }}
//             style={{
//               // height: '20px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//           >
//             {currentLang === 'en' ? (
//               <img
//                 src={imgen}
//                 alt=""
//                 style={{
//                   width: '20px',
//                   height: '20px',
//                   cursor: 'pointer',
//                 }}
//               />
//             ) : (
//               <img
//                 src={imgar}
//                 alt=""
//                 style={{
//                   width: '20px',
//                   height: '20px',
//                   cursor: 'pointer',
//                 }}
//               />
//             )}
//           </Dropdown>
//         </div>

//         <div
//           className="dark"
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           {darkMode ? (
//             <div
//               style={{
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//               onClick={() => handleDarkMode(false)}
//             >
//               <MdLightMode size={30} color="#fff" />
//             </div>
//           ) : (
//             <div
//               style={{
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//               onClick={() => handleDarkMode(true)}
//             >
//               <MdOutlineDarkMode size={30} style={{ color: '#878a99' }} />
//             </div>
//           )}
//         </div>
//         <div className="">
//           <Dropdown
//             rootClassName="dropdown-style-own"
//             arrow={{ pointAtCenter: true }}
//             placement="bottom"
//             menu={{
//               items: itemsNotification,
//               onClick: (e) => {
//                 console.log(e);
//               },
//             }}
//             trigger={['click']}
//             // placement="bottom"
//           >
//             <Flex className="own-header-space" align="center" gap="5px">
//               <Badge
//                 count={notifications?.message?.notification_logs?.length}
//                 size="small"
//                 className="badge-style"
//               >
//                 <Avatar
//                   size={38 * 0.8}
//                   style={{
//                     backgroundColor: 'transparent',
//                     color: darkMode ? '#fff' : '#878a99',
//                   }}
//                   icon={<IoNotificationsOutline size={25} />}
//                 />
//               </Badge>
//             </Flex>
//           </Dropdown>
//         </div>
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             height: '70px',
//           }}
//         >
//           <Dropdown
//             menu={{
//               items: [
//                 {
//                   key: '0',
//                   label: (
//                     <h3 className="text-[#878a99] text-[12px]">{`Welcome ${userName}!`}</h3>
//                   ),
//                   type: 'group',
//                 },
//                 {
//                   key: '1',
//                   label: (
//                     <span onClick={() => navigate('/profile-user')}>
//                       {currentLang === 'en' ? 'Profile' : 'الملف الشخصي'}
//                     </span>
//                   ),
//                   icon: <UserOutlined />,
//                 },
//                 {
//                   key: '2',
//                   label: (
//                     <span onClick={() => navigate('/todo-list')}>
//                       {currentLang === 'en' ? 'Todo List' : 'قائمة الأعمال'}
//                     </span>
//                   ),
//                   icon: <LuListTodo />,
//                 },
//                 {
//                   type: 'divider',
//                 },
//                 {
//                   key: '3',
//                   label: currentLang === 'en' ? 'Logout' : 'تسجيل الخروج',
//                   //   label: 'Logout',
//                   icon: <LogoutOutlined />,
//                   danger: true,
//                 },
//               ],
//               onClick: (e) => {
//                 console.log(e);
//                 if (e?.key === '3') {
//                   handleSignOut();
//                 }
//               },
//             }}
//             trigger={['click']}
//             placement="bottom"
//             className="h-full"
//             arrow={false}
//           >
//             <div className="flex items-center gap-2 justify-center bg-[#f3f3f9] py-[8px] px-[14.4px]">
//               <div className="">
//                 <img
//                   src={imgavater}
//                   alt=""
//                   style={{ width: '50px', height: '50px', borderRadius: '50%' }}
//                 />
//               </div>
//               <div className="flex flex-col">
//                 <h2 className="h-[20px] flex items-center justify-center text-[#495057] font-[500] text-[14px]">
//                   {userName}
//                 </h2>
//                 <p className="h-[20px] flex items-center justify-center text-[#878a99] font-[500] text-[12px]">
//                   {companyName}
//                 </p>
//               </div>
//             </div>
//           </Dropdown>
//           <Divider type="vertical" />
//         </div>
//       </Flex>
//       <MobileMenu
//         currentLang={currentLang}
//         open={openMenu}
//         setOpen={setOpenMenu}
//       />
//     </div>
//   );
// };

// export default Header;
import React, { useState } from 'react';
import {
  clearUser,
  setCurrentLang,
  setDarkMode,
} from '../services/store/slices/user';
import { useDispatch, useSelector } from 'react-redux';
import {
  Badge,
  Button,
  Divider,
  Dropdown,
  Flex,
  Input,
  Avatar,
  Tag,
  Tabs,
  Checkbox,
  Spin,
  Select,
} from 'antd';
import { IoCheckmarkDoneCircleOutline, IoSearchOutline } from 'react-icons/io5';
import { RiFullscreenLine } from 'react-icons/ri';
import { CgMenuLeft, CgMenuRight } from 'react-icons/cg';
import { LiaLongArrowAltRightSolid } from 'react-icons/lia';
import {
  MdClose,
  MdKeyboardArrowDown,
  MdOutlineDarkMode,
} from 'react-icons/md';
import { IoNotificationsOutline } from 'react-icons/io5';
import {
  MdDarkMode,
  MdLanguage,
  MdLightMode,
  MdOutlineSearch,
} from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  UserOutlined,
  DownOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import SearchComponent from './InputSearchHeader';
import imgen from '../assets/us.svg';
import imgar from '../assets/ae.svg';
// import imgavater from '../assets/avatar-1.jpg';
import imgavater from '../assets/user_prof.png';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { CiClock2, CiSearch } from 'react-icons/ci';
import { queryKeys } from '../services/react-query/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { getNotifications } from '../network/notifications';
import dayjs from 'dayjs';
import { LuListTodo } from 'react-icons/lu';
import MobileMenu from './MobileMenu';
const Header = ({ collapsed, setCollapsed, t }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const { currentLang, darkMode, userName, companyName } = useSelector(
    (state) => state.user
  );
  const handleDarkMode = (dark) => {
    dispatch(setDarkMode(dark));
  };
  const { data: notifications, isLoading } = useQuery({
    queryKey: [queryKeys.getNotifications],
    queryFn: () => getNotifications(currentLang),
  });
  const items = [
    {
      key: 'en',
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={imgen}
            alt="en"
            style={{ width: '15px', height: '15px', cursor: 'pointer' }}
          />
          <span
            style={{ marginLeft: '10px' }}
            className="text-[#272a3a] font-[400] text-[14px]"
          >
            English
          </span>
        </div>
      ),
    },
    {
      key: 'ar',
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={imgar} alt="ar" style={{ width: '15px', height: '15px' }} />
          <span
            style={{ marginLeft: '10px' }}
            className="text-[#272a3a] font-[400] text-[14px]"
          >
            العربية
          </span>
        </div>
      ),
    },
  ];
  const handleSignOut = () => {
    dispatch(clearUser());
    localStorage.clear();
    navigate('/login');
  };
  const itemsTabs = [
    {
      key: '1',
      label: `All (${notifications?.message?.notification_logs?.length || 0})`,
      children: (
        <>
          {isLoading ? (
            <div className="flex items-center justify-center h-[200px]">
              <Spin />
            </div>
          ) : (
            <div className="">
              {notifications?.message?.notification_logs?.map((item, id) => (
                <div
                  key={id}
                  // className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#DAF7FE] cursor-pointer"
                  className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#dafee3] cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    const name = item?.document_type
                      .replace(/ /g, '-')
                      .toLowerCase();
                    navigate(`/${name}/edit/${item?.document_name}`);
                  }}
                >
                  <div className=" w-[30px] h-[20px] bg-[#DAF7FE] rounded-[50%] flex items-center justify-center">
                    <IoCheckmarkDoneCircleOutline
                      className="text-[#0b9640]"
                      size={15}
                    />
                  </div>
                  <div className="flex flex-col items-start gap-2">
                    <h3 className="text-[#495057] text-[.875rem] font-[600] flex items-center flex-wrap gap-1">
                      Your <b>{item?.from_user}</b>
                      {/* {item?.description} */}
                      <div
                        className=""
                        dangerouslySetInnerHTML={{ __html: item?.subject }}
                      />
                    </h3>
                    <p className="text-[#878a99]  font-[500] text-[12px] flex items-center gap-1">
                      {' '}
                      <CiClock2 />{' '}
                      {dayjs(item?.creation).format('YYYY-MM-DD h:m')}
                    </p>
                  </div>
                  <Checkbox />
                </div>
              ))}
            </div>
          )}
        </>
      ),
    },
    // {
    //   key: '2',
    //   label: 'Message',
    //   children: (
    //     <>
    //       <div className="">
    //         {[1, 2, 3, 4]?.map((item) => (
    //           <div
    //             key={item}
    //             className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#DAF7FE] cursor-pointer"
    //             onClick={(e) => e.stopPropagation()}
    //           >
    //             <div className=" w-[30px] h-[20px] bg-[#DAF7FE] rounded-[50%] flex items-center justify-center">
    //               <IoCheckmarkDoneCircleOutline
    //                 className="text-[#687cfe]"
    //                 size={15}
    //               />
    //             </div>
    //             <div className="flex flex-col items-start gap-2">
    //               <h3 className="text-[#495057] text-[.875rem] font-[600] flex items-center flex-wrap gap-1">
    //                 Your <b>Elite</b>
    //                 author Graphic Optimization
    //                 <p className="text-[#ff7f5d]">reward</p>
    //                 is ready!
    //               </h3>
    //               <p className="text-[#878a99]  font-[500] text-[12px] flex items-center gap-1">
    //                 {' '}
    //                 <CiClock2 /> Just 30 sec ago
    //               </p>
    //             </div>
    //             <Checkbox />
    //           </div>
    //         ))}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   key: '3',
    //   label: 'Alerts',
    //   children: (
    //     <>
    //       <div className="">
    //         {[1, 2, 3, 4]?.map((item) => (
    //           <div
    //             key={item}
    //             className="py-[.75rem] px-[1rem] flex items-start justify-between gap-5 hover:bg-[#DAF7FE] cursor-pointer"
    //             onClick={(e) => e.stopPropagation()}
    //           >
    //             <div className=" w-[30px] h-[20px] bg-[#DAF7FE] rounded-[50%] flex items-center justify-center">
    //               <IoCheckmarkDoneCircleOutline
    //                 className="text-[#687cfe]"
    //                 size={15}
    //               />
    //             </div>
    //             <div className="flex flex-col items-start gap-2">
    //               <h3 className="text-[#495057] text-[.875rem] font-[600] flex items-center flex-wrap gap-1">
    //                 Your <b>Elite</b>
    //                 author Graphic Optimization
    //                 <p className="text-[#ff7f5d]">reward</p>
    //                 is ready!
    //               </h3>
    //               <p className="text-[#878a99]  font-[500] text-[12px] flex items-center gap-1">
    //                 {' '}
    //                 <CiClock2 /> Just 30 sec ago
    //               </p>
    //             </div>
    //             <Checkbox />
    //           </div>
    //         ))}
    //       </div>
    //     </>
    //   ),
    // },
  ];
  const itemsNotification = [
    {
      type: 'group',
      label: (
        <>
          <div
            className="bg-[#0b9640] p-3 flex items-center justify-between"
            onClick={(e) => e.stopPropagation()}
          >
            <h6 className="text-[#fff]">Notifications</h6>
            <Tag
              color="#f9fbfc"
              style={{
                color: '#272a3a',
              }}
            >
              {notifications?.message?.notification_logs?.length} New
            </Tag>
          </div>
        </>
      ),
      children: [1]?.map((item) => ({
        key: item?.key,
        label: (
          <>
            <div
              className="notification-card"
              onClick={(e) => e.stopPropagation()}
            >
              <Tabs defaultActiveKey="1" items={itemsTabs} type="card" />
            </div>
          </>
        ),
      })),
    },
    // {
    //   label: "مشاهدة الكل",
    //   key: "30",
    //   className: "view-all",
    //   onClick: () => {
    //     console.log("click");
    //   }
    // },
  ];
  const chanageLang = ({ key }) => {
    console.log(key);
    dispatch(setCurrentLang(key));
    document.getElementsByTagName('html')[0].setAttribute('lang', key);
  };
  const handleFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };
  return (
    <div
      className="header"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
      }}
    >
      <Flex
        align="center"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
        }}
      >
        <Button
          type="text"
          icon={
            collapsed ? (
              <LiaLongArrowAltRightSolid size={25} />
            ) : (
              <CgMenuLeft size={25} />
            )
          }
          onClick={() => setCollapsed(!collapsed)}
          className="lg:flex hidden"
          style={{
            fontSize: '16px',
          }}
        />
        <Button
          type="text"
          danger={openMenu ? true : false}
          icon={openMenu ? <MdClose size={25} /> : <CgMenuLeft size={25} />}
          onClick={() => setOpenMenu(!openMenu)}
          className="flex lg:hidden"
          style={{
            fontSize: '16px',
          }}
        />
        {/* <Input.Search
          className={`search-input ${
            darkMode ? 'dark-search' : 'light-search'
          }`}
          placeholder="search..."
          allowClear
          onSearch={(value) => console.log(value)}
          enterButton={false}
          width={200}
          prefix={<MdOutlineSearch style={{ color: '#495057' }} size={18} />}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        /> */}
        <div className="hidden lg:flex">
          <Input
            placeholder={t.Search}
            allowClear
            onChange={(value) => console.log(value)}
            // enterButton={false}
            width={480}
            prefix={<CiSearch style={{ color: '#495057' }} size={18} />}
            // classNames="!hidden "
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#FFFFFF',
            }}
            className="!w-[480px]"
          />
        </div>
        {/* <div className="flex lg:hidden">
          <Button
            type="text"
            // danger={openMenu ? true : false}
            // icon={openMenu ? <MdClose size={25} /> : <CgMenuLeft size={25} />}
            icon={<CgMenuLeft size={25} />}
            onClick={() => setOpenMenu(!openMenu)}
            // className="flex lg:hidden"
            style={{
              fontSize: '16px',
            }}
          />
        </div> */}
        {/* <SearchComponent /> */}
      </Flex>
      <Flex align="center" className="own-header-space">
        {/* <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div onClick={handleFullScreen} className="fullscreen">
            <RiFullscreenLine size={25} color={darkMode ? '#fff' : '#505d69'} />
          </div>
        </div> */}
        {/* <div className="language">
          <Dropdown
            placement="bottom"
            arrow={{ pointAtCenter: true }}
           
            trigger={['hover']}
            menu={{ items: items, onClick: chanageLang }}
            style={{
              height: '20px',
            }}
          >
            <Space
              align="center"
              style={{
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                height: '20px',
              }}
              className="lang-dropdown"
            >
              <span className="lang-text">
                {currentLang === 'en' ? 'Language' : 'اللغة'}
             
              </span>
              <MdLanguage />
            </Space>
          </Dropdown>
        </div> */}
        {/* <div
          className=""
          style={{
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        > */}
        {/* <Dropdown
            placement="bottom"
            arrow={{ pointAtCenter: true }}
            trigger={['hover']}
            menu={{ items: items, onClick: chanageLang }}
            style={{
              // height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {currentLang === 'en' ? (
              <img
                src={imgen}
                alt=""
                style={{
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                }}
              />
            ) : (
              <img
                src={imgar}
                alt=""
                style={{
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                }}
              />
            )}
          </Dropdown> */}
        <Select
          defaultValue={currentLang}
          // className="mb-4"
          bordered={false}
          popupMatchSelectWidth={false}
          suffixIcon={<MdKeyboardArrowDown color="#374151" size={16} />}
          prefix={<MdLanguage color="#374151" size={16} />}
          options={[
            { value: 'en', label: 'English' },
            { value: 'ar', label: 'عربى' },
          ]}
          onChange={(value) => chanageLang({ key: value })}
        />
        {/* </div> */}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '70px',
          }}
        >
          {/* <Dropdown
            menu={{
              items: [
                {
                  key: '0',
                  label: (
                    <h3 className="text-[#878a99] text-[12px]">{`Welcome ${userName}!`}</h3>
                  ),
                  type: 'group',
                },
                {
                  key: '1',
                  label: (
                    <span onClick={() => navigate('/profile-user')}>
                      {currentLang === 'en' ? 'Profile' : 'الملف الشخصي'}
                    </span>
                  ),
                  icon: <UserOutlined />,
                },
                {
                  key: '2',
                  label: (
                    <span onClick={() => navigate('/todo-list')}>
                      {currentLang === 'en' ? 'Todo List' : 'قائمة الأعمال'}
                    </span>
                  ),
                  icon: <LuListTodo />,
                },
                {
                  type: 'divider',
                },
                {
                  key: '3',
                  label: currentLang === 'en' ? 'Logout' : 'تسجيل الخروج',
                  //   label: 'Logout',
                  icon: <LogoutOutlined />,
                  danger: true,
                },
              ],
              onClick: (e) => {
                console.log(e);
                if (e?.key === '3') {
                  handleSignOut();
                }
              },
            }}
            trigger={['click']}
            placement="bottom"
            className="h-full"
            arrow={false}
          >
            <div className="flex items-center gap-2 justify-center bg-[#f3f3f9] py-[8px] px-[14.4px]">
              <div className="">
                <img
                  src={imgavater}
                  alt=""
                  style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                />
              </div>
              <div className="flex flex-col">
                <h2 className="h-[20px] flex items-center justify-center text-[#495057] font-[500] text-[14px]">
                  {userName}
                </h2>
                <p className="h-[20px] flex items-center justify-center text-[#878a99] font-[500] text-[12px]">
                  {companyName}
                </p>
              </div>
            </div>
          </Dropdown>
          <Divider type="vertical" /> */}
          <Dropdown
            menu={{
              items: [
                {
                  key: '0',
                  label: (
                    <h3 className="text-[#878a99] text-[12px]">{`${t.Welcome} ${
                      userName?.length > 15
                        ? `${userName?.slice(0, 15)}...`
                        : userName
                    } `}</h3>
                  ),
                  type: 'group',
                },
                {
                  key: '1',
                  label: (
                    <span onClick={() => navigate('/profile-user')}>
                      {currentLang === 'en' ? 'Profile' : 'الملف الشخصي'}
                    </span>
                  ),
                  icon: <UserOutlined />,
                },
                {
                  key: '2',
                  label: (
                    <span onClick={() => navigate('/todo-list')}>
                      {currentLang === 'en' ? 'Todo List' : 'قائمة الأعمال'}
                    </span>
                  ),
                  icon: <LuListTodo />,
                },
                {
                  type: 'divider',
                },
                {
                  key: '3',
                  label: currentLang === 'en' ? 'Logout' : 'تسجيل الخروج',
                  //   label: 'Logout',
                  icon: <LogoutOutlined />,
                  danger: true,
                },
              ],
              onClick: (e) => {
                console.log(e);
                if (e?.key === '3') {
                  handleSignOut();
                }
              },
            }}
            trigger={['click']}
            placement="bottom"
            className="h-full cursor-pointer"
            arrow={false}
          >
            <div className="flex items-center gap-2 justify-center">
              <div
                className="border-[2px] border-[#fff] rounded-full w-[42px] h-[42px] flex items-center justify-center"
                style={{
                  boxShadow: '-4px 8px 8px 0px #4361EE1F',
                }}
              >
                <img
                  src={imgavater}
                  alt="img avater"
                  style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                />
              </div>
              <div className="flex flex-col">
                <h2 className="h-[20px] flex items-center justify-center text-[#374151] font-[700] text-[12px] font-Comfortaa">
                  {userName || 'Admin User'}
                </h2>
                <p className="h-[20px] flex items-center justify-center text-[#6B7280] font-[500] text-[12px] font-Comfortaa">
                  {/* مسؤلية الشخص هنا */}
                  {currentLang === 'en' ? 'Supervisor' : 'مسؤلية الشخص هنا'}
                </p>
              </div>
              <MdKeyboardArrowDown color="#374151" size={16} />
            </div>
          </Dropdown>
          {/* <Divider type="vertical" /> */}
          <div className="w-[1px] h-[24px] bg-[#3367E0] mx-[16px]" />
          <Dropdown
            rootClassName="dropdown-style-own"
            arrow={{ pointAtCenter: true }}
            placement="bottom"
            menu={{
              items: itemsNotification,
              onClick: (e) => {
                console.log(e);
              },
            }}
            trigger={['click']}
            // placement="bottom"
          >
            {/* <Flex className="own-header-space" align="center" gap="5px">
              <Badge
                count={notifications?.message?.notification_logs?.length}
                size="small"
                className="badge-style"
              >
                <Avatar
                  size={38 * 0.8}
                  style={{
                    backgroundColor: 'transparent',
                    color: darkMode ? '#fff' : '#878a99',
                  }}
                  icon={<IoNotificationsOutline size={25} />}
                />
              </Badge>
            </Flex> */}
            <div
              className="bg-[#fff] rounded-[50%] w-[36px] h-[36px] flex items-center justify-center "
              style={{
                boxShadow: '0px 8px 8px 0px #4361EE14',
              }}
            >
              <Badge
                count={notifications?.message?.notification_logs?.length}
                size="small"
                className="badge-style"
                style={{
                  backgroundColor: '#079661',
                  color: '#fff',
                  fontSize: '20px',
                  fontWeight: '700',
                  right: '-10px',
                }}
              >
                {/* <img
                src={notificationIcon}
                alt="notification"
                style={{
                  width: '24px',
                  height: '24px',
                  cursor: 'pointer',
                }}
              /> */}
                <IoNotificationsOutline
                  color="#292D32"
                  size={24}
                  style={{ cursor: 'pointer' }}
                  // onClick={() => navigate('/notifications')}
                />
              </Badge>
            </div>
          </Dropdown>
        </div>
      </Flex>
      <MobileMenu
        currentLang={currentLang}
        open={openMenu}
        setOpen={setOpenMenu}
      />
    </div>
  );
};

export default Header;
